import React from 'react';
import { cn } from '../../utils/cn';

export type AgentStatusType = 'online' | 'available' | 'busy' | 'away' | 'offline';

export interface AgentStatusProps {
  status: AgentStatusType;
  agentName?: string;
  className?: string;
  showLabel?: boolean;
}

export const AgentStatus: React.FC<AgentStatusProps> = ({
  status,
  agentName,
  className,
  showLabel = true,
}) => {
  const statusConfig = {
    online: {
      color: 'bg-success-500',
      label: 'Online',
      icon: '🟢',
    },
    available: {
      color: 'bg-success-500',
      label: 'Available',
      icon: '🟢',
    },
    busy: {
      color: 'bg-warning-500',
      label: 'Busy',
      icon: '🟡',
    },
    away: {
      color: 'bg-warning-500',
      label: 'Away',
      icon: '🟠',
    },
    offline: {
      color: 'bg-gray-400',
      label: 'Offline',
      icon: '⚫',
    },
  };

  const config = statusConfig[status];

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <div className={cn('w-3 h-3 rounded-full', config.color)} />
      {showLabel && (
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {agentName ? `${agentName} - ${config.label}` : config.label}
        </span>
      )}
    </div>
  );
};
